(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-real-moments"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){
  var button=event.target.closest('.ss-real-moments__launch');
  if(!button)return;
  var card=button.closest('.ss-real-moments__card');
  var section=button.closest('.ss-real-moments');
  var video=card.querySelector('video');
  section.querySelectorAll('video[data-ss-poster]').forEach(function(v){v.poster=v.getAttribute('data-ss-poster');v.removeAttribute('data-ss-poster')});
  section.querySelectorAll('.ss-real-moments__card.is-playing').forEach(function(other){
    if(other===card)return;
    var otherVideo=other.querySelector('video');
    otherVideo.pause();otherVideo.controls=false;otherVideo.load();other.classList.remove('is-playing');
  });
  video.controls=true;video.muted=false;
  video.play().then(function(){
    card.classList.add('is-playing');
    if(card.dataset.ssrmEnded!=='true'){
      video.addEventListener('ended',function(){video.controls=false;video.load();card.classList.remove('is-playing')});
      card.dataset.ssrmEnded='true';
    }
  }).catch(function(){video.controls=false});
});
// Pause a playing video (it plays with sound) once it is less than half on screen, whether
// the page scrolls past it or the rail swipes to the other card, and when the tab is hidden.
// No auto-resume: restarting sound unasked is worse; the native controls stay up to resume.
(function(){
  if(!('IntersectionObserver' in window))return;
  var io=new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if(entry.intersectionRatio<0.5&&!entry.target.paused)entry.target.pause();
    });
  },{threshold:[0,0.5]});
  function watch(){
    document.querySelectorAll('.ss-real-moments video').forEach(function(video){
      if(video.dataset.ssrmWatch)return;
      video.dataset.ssrmWatch='1';
      io.observe(video);
    });
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watch);else watch();
  document.addEventListener('shopify:section:load',watch);
  document.addEventListener('visibilitychange',function(){
    if(!document.hidden)return;
    document.querySelectorAll('.ss-real-moments video').forEach(function(video){if(!video.paused)video.pause()});
  });
})();

  } catch(e) { console.error(e); }
})();
})();
